<template>
  <div class="container page">
    <van-nav-bar :title="$t('setting.fill_bank')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>
    <van-button v-if="!passwordReady && !passwordSetupOpen" class="bindCard" :loading="passwordStatusLoading" @click="prepareBankBinding">確認帳戶安全並繼續</van-button>
    <div v-if="passwordReady" style="padding: 1rem;">
      <div class="main-box bc-body">
        <div class="label">{{ $t("setting.fill_bank_tip") }}</div>
        <van-cell-group
          class="manual-bank-fields"
          @copy.native.prevent
          @cut.native.prevent
          @paste.native.prevent
          @drop.native.prevent
          @dragstart.native.prevent
          @contextmenu.native.prevent
          @beforeinput.native="guardBankAccountInput"
        >
          <van-field
            v-model="username"
            autocomplete="off"
            autocorrect="off"
            autocapitalize="off"
            :spellcheck="false"
            :label="'真實姓名'"
            :placeholder="$t('setting.username_place')"
          />
          <van-field
            v-model="bank_code"
            autocomplete="off"
            autocorrect="off"
            autocapitalize="off"
            :spellcheck="false"
            inputmode="numeric"
            :label="$t('setting.bank_code')"
            :placeholder="$t('setting.bank_code_tip')"
          />
          <van-field
            v-model="bankid"
            inputmode="numeric"
            autocomplete="off"
            autocorrect="off"
            autocapitalize="off"
            :spellcheck="false"
            :label="'銀行帳號'"
            type="text"
            :placeholder="'請輸入銀行帳號'"
          />
          <van-field
            v-model="branch_name"
            autocomplete="off"
            autocorrect="off"
            autocapitalize="off"
            :spellcheck="false"
            :label="'銀行分行'"
            :placeholder="$t('setting.branch_name_tip')"
          />
        </van-cell-group>
      </div>
    </div>
    <p v-if="passwordReady" class="bank-warning">{{ $t("setting.bank_warn") }}</p>
    <van-button v-if="passwordReady" class="bindCard" type="default" :loading="saving" :disabled="saving" @click="bindCard()">{{
      $t("setting.bank_ok")
    }}</van-button>

    <withdrawal-password-gate v-model="passwordSetupOpen" :is-setup="true" @complete="finishPasswordSetup" @cancel="cancelPasswordSetup" />
  </div>
</template>

<script>
import withdrawalPassword from "../../common/withdrawal-password"
export default {
  mixins: [withdrawalPassword],
  data() {
    return {
      userInfo: {},
      bankid: "",
      username: "",
      mobile: "",
      saving: false,
      passwordReady: false,
      is_bind: false,
      bank: "",
      branch_name: "",
      bank_code: "",
    };
  },
  methods: {
    guardBankAccountInput(event) {
      if (/^insert(?:FromPaste|FromDrop|ReplacementText)/.test(String(event.inputType || ''))) {
        event.preventDefault();
      }
    },
    prepareBankBinding() {
      return this.ensureWithdrawalPassword(() => { this.passwordReady = true; this.getUserBankInfo(); }, () => this.$router.replace({ path: "/Setbank" }));
    },
    back() {
      return window.history.back();
    },
    async bindCard() {
      if (this.saving || !this.passwordReady) return;
      if (this.is_bind) { this.$toast('已綁定銀行帳戶，修改資料請聯絡管理員'); return; }
      const fields = [['username', '真實姓名'], ['bank_code', '銀行代碼'], ['bankid', '銀行帳號'], ['branch_name', '銀行分行']];
      for (const [key, label] of fields) {
        this[key] = String(this[key] || '').trim();
        if (!this[key]) { this.$toast('請輸入' + label); return; }
      }
      this.saving = true;
      try {
        const res = await this.$http({method:'post',url:'user_set_bank',data:{
          bankid:this.bankid,bank_code:this.bank_code,branch_name:this.branch_name,
          username:this.username,
        }});
        if (res && res.code === 200) {
          this.$toast(res.msg || '銀行帳戶綁定成功');
          this.$router.replace({path:'/Setbank'});
        } else { this.$toast((res && res.msg) || '綁定失敗，請重試'); }
      } catch (error) { this.$toast('連線失敗，請稍後重試'); }
      finally { this.saving = false; }
    },
    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.name = res.data.name;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getBankList() {
      this.$http({
        method: "get",
        url: "sys_get_banks",
      }).then((res) => {
        if (res.code === 200) {
          this.banks = res.data;
          console.log("获取到的银行:", res.data);
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserBankInfo() {
      this.$http({
        method: "get",
        url: "user_get_bank",
      }).then((res) => {
        if (res.code === 200) {
          if (res.data.is_bank) {
            this.is_bind = true;
          } else {
            this.is_bind = false;
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.prepareBankBinding();
    }
  },
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.less";
::v-deep .van-cell-group {
  background: none;
}
::v-deep .van-field__control{
  color: #ccc;
}
.bc-body {
  padding: 1rem;
  border: 3px solid #ac7254;
  border-radius: 2rem;
}
.van-cell {
  font-size: 32px;
  line-height: 80px;
  background: none;
}
.van-hairline--bottom::after {
  border-bottom-width: 3px;
}
.bankbox {
  padding: 15px;
  color: #000;
  background-color: #fff;
}
.bankbox .title {
  padding: 8px 10px 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 28px;
}
.main-box {
  // background: #fff;
}
.main-box .label {
  padding: 20px;
  font-size: 35px;
  color: #797878;
}
::v-deep .van-picker__toolbar {
  height: 50px;
}
/deep/ .van-picker__cancel,
/deep/ .van-picker__confirm {
  padding: 0 20px;
  font-size: 40px !important;
}
::v-deep .van-picker-column {
  font-size: 40px;
}
.bank-warning {
  margin: 0 30px;
  padding: 0 0.25rem;
  color: #ee0a24;
  font-size: 0.65rem;
  font-weight: 700;
  line-height: 1.45;
}
.bindCard {
  margin: 20px 30px 0;
  height: 80px;
  line-height: 1.22667rem;
  border-radius: 50px;
  color: #fff;
  font-size: 30px;
  font-weight: bolder;
  border: none;
  background: linear-gradient(90deg, #EEC094, #F3C7A2);
}
::v-deep .manual-bank-fields input {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}
</style>
